import { motion } from "framer-motion";
import { MANIFESTO } from "@/data";

export default function Manifesto() {
  return (
    <section id="vision" data-testid="vision-section" className="bg-light-gray py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="mb-16 max-w-3xl">
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-emerald-green">
            Our Vision
          </span>
          <h2 className="mt-3 font-heading text-4xl font-extrabold leading-tight tracking-tight text-deep-trust-blue sm:text-5xl">
            A manifesto for the AI-enabled village.
          </h2>
        </div>

        <div className="space-y-6">
          {MANIFESTO.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="group grid grid-cols-1 items-center gap-6 border-t border-deep-trust-blue/10 py-10 md:grid-cols-12"
            >
              <div className="md:col-span-3">
                <span className="font-heading text-7xl font-extrabold leading-none text-stroke-orange transition-all duration-500 group-hover:text-vibrant-orange md:text-8xl">
                  {c.n}
                </span>
              </div>
              <h3 className="font-heading text-2xl font-bold tracking-tight text-deep-trust-blue md:col-span-4 md:text-3xl">
                {c.title}
              </h3>
              <p className="text-base leading-relaxed text-deep-trust-blue/65 md:col-span-5 md:text-lg">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
